// dependencies
import React from "react";

// components
import Logo from "Components/CompanyLogo";

import css from "./Company";

const CustomUserOption = (props) => {
	const { innerProps, innerRef, isDisabled, isFocused, data } = props;

	if (isDisabled) {
		return null;
	}

	return (
		<div ref={innerRef} className={`${css.Container} ${isFocused ? css.hasFocus : ""}`} {...innerProps}>
			<Logo className={css.Avatar} companyID={data.companyID} />
			<div className={css.Name}>{data.companyName}</div>
		</div>
	);
};

export default CustomUserOption;
